const combineValues = (...objects) => objects.reduce((acc, obj) => [...acc, ...Object.values(obj)], []);

// Sequencer
const VPP_SEQUENCER_DATADOG_KEY_PREFIX = 'vpp_sequencer_fe';
const VPP_SEQUENCER_DATADOG_KEY_CASES = {
  ACTION_CLICK: 'action_click',
  WEBVIEW_REDIRECT: 'webview_redirect',
  FLOW_END: 'flow_end',
  GET_RESPONSE: 'get_response',
  REDIRECT_TO_FALLBACK: 'redirect_to_fallback',
  SHOW_SNACKBAR: 'show_snackbar',
  VPP_LOAD: 'vpp_load',
  DISPLAY_INSTANTLY: 'display_instantly',
  PRELOAD_LOADING: 'preload_loading',
  PRELOAD_LOADED: 'preload_loaded',
  PRELOAD_SHOWN: 'preload_shown',
  PRELOAD_UPDATED: 'preload_updated',
  SEQUENCER_UPDATE_FROM_MSG: 'sequencer_update_from_msg',
  GET_RESPONSE_FROM_MSG: 'get_response_from_msg',
};

// Add to cart
const ADD_TO_CART_DATADOG_KEY_PREFIX = 'vpp_add_to_cart';
const ADD_TO_CART_DATADOG_KEY_CASES = {
  FLOW_TYPE: 'flow_type',
};

// Questions AI
const QUESTIONS_AI_DATADOG_KEY_PREFIX = 'vpp_questions_ai_fe';
const QUESTIONS_AI_DATADOG_KEY_CASES = {
  VPP_LOAD: 'vpp_load',
  QUESTION_LOAD: 'question_load',
  WEBVIEW_LOAD: 'webview_load',
  SUGGESTION_RESPONSE: 'suggestion_response',
  BAD_FEEDBACK: 'bad_feedback',
  ACTION_CLICK: 'action_click',
  FLOW_END: 'flow_end',
  SHOW_SNACKBAR: 'show_snackbar',
};

// Observability
const VPP_OBSERVABILITY_DATADOG_KEY_PREFIX = 'vpp_observability_fe';
const VPP_OBSERVABILITY_DATADOG_KEY_CASES = {
  OBSERVABILITY_INITIAL_REQUEST: 'observability_initial_request',
};

// Error boundary
const VPP_BOUNDARY_DATADOG_KEY_PREFIX = 'vpp_boundary_fe';
const VPP_BOUNDARY_DATADOG_KEY_CASES = {
  ERROR_BOUNDARY_COMPONENT: 'error_boundary_component',
  ERROR_BOUNDARY_MIDDLEWARE: 'error_boundary_middleware',
  ERROR_BOUNDARY_GLOBAL: 'error_boundary_global',
  ERROR_BOUNDARY_TRY_CATCH: 'error_boundary_try_catch',
  ERROR_BOUNDARY_COMPONENT_PRINT: 'error_boundary_component_print',
};

// Error Handler
const VPP_ERROR_HANDLER_DATADOG_KEY_PREFIX = 'vpp_error_handler';
const VPP_ERROR_HANDLER_DATADOG_KEY_CASES = {
  JS_ERROR: 'js_error',
  SCRIPT_CATCH: 'script_catch',
};

// Post message
const VPP_POSTMESSAGE_DATADOG_KEY_PREFIX = 'vpp_postmessage';
const VPP_POSTMESSAGE_DATADOG_KEY_CASES = { VALIDATE_ORIGIN: 'validate_origin' };

// Buy Box Winner
const VPP_BUY_BOX_WINNER_DATADOG_KEY_PREFIX = 'vpp_buy_box_winner';
const VPP_BUY_BOX_WINNER_DATADOG_KEY_CASES = {
  DISCREPANCY: 'discrepancy',
};

// All prefixes
const ALLOWED_KEY_PREFIXES = [
  VPP_SEQUENCER_DATADOG_KEY_PREFIX,
  ADD_TO_CART_DATADOG_KEY_PREFIX,
  QUESTIONS_AI_DATADOG_KEY_PREFIX,
  VPP_OBSERVABILITY_DATADOG_KEY_PREFIX,
  VPP_BOUNDARY_DATADOG_KEY_PREFIX,
  VPP_ERROR_HANDLER_DATADOG_KEY_PREFIX,
  VPP_POSTMESSAGE_DATADOG_KEY_PREFIX,
  VPP_BUY_BOX_WINNER_DATADOG_KEY_PREFIX,
];

// All cases
const ALLOWED_KEYS_CASES = combineValues(
  VPP_SEQUENCER_DATADOG_KEY_CASES,
  ADD_TO_CART_DATADOG_KEY_CASES,
  QUESTIONS_AI_DATADOG_KEY_CASES,
  VPP_OBSERVABILITY_DATADOG_KEY_CASES,
  VPP_BOUNDARY_DATADOG_KEY_CASES,
  VPP_ERROR_HANDLER_DATADOG_KEY_CASES,
  VPP_POSTMESSAGE_DATADOG_KEY_CASES,
  VPP_BUY_BOX_WINNER_DATADOG_KEY_CASES,
);

export {
  ALLOWED_KEY_PREFIXES,
  ALLOWED_KEYS_CASES,
  VPP_SEQUENCER_DATADOG_KEY_CASES,
  VPP_SEQUENCER_DATADOG_KEY_PREFIX,
  ADD_TO_CART_DATADOG_KEY_CASES,
  ADD_TO_CART_DATADOG_KEY_PREFIX,
  QUESTIONS_AI_DATADOG_KEY_PREFIX,
  QUESTIONS_AI_DATADOG_KEY_CASES,
  VPP_OBSERVABILITY_DATADOG_KEY_PREFIX,
  VPP_OBSERVABILITY_DATADOG_KEY_CASES,
  VPP_BOUNDARY_DATADOG_KEY_PREFIX,
  VPP_BOUNDARY_DATADOG_KEY_CASES,
  VPP_ERROR_HANDLER_DATADOG_KEY_PREFIX,
  VPP_ERROR_HANDLER_DATADOG_KEY_CASES,
  VPP_BUY_BOX_WINNER_DATADOG_KEY_PREFIX,
  VPP_BUY_BOX_WINNER_DATADOG_KEY_CASES,
  VPP_POSTMESSAGE_DATADOG_KEY_PREFIX,
  VPP_POSTMESSAGE_DATADOG_KEY_CASES,
};
